/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { login } from '../redux/AuthCRUD'
import { FirebaseError } from '@firebase/util'
import { getFirebaseError } from '../../../../_metronic/helpers/FirebaseErrorHandler'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  email: '',
  password: '',
}

export function Login() {
  const [loading, setLoading] = useState(false)

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      setTimeout(() => {
        login(values.email, values.password)
          .then(() => {
            
          })
          .catch((error) => {
            if (error instanceof FirebaseError) {
              console.log(error.code)
              setStatus(getFirebaseError(error))
            } else {
              setStatus('Unknown Error')
            }
            setLoading(false)
            setSubmitting(false)
          })
      }, 1000)
    },
  })

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      <div className='text-center mb-10'>
        <h1 className='text-white mb-3'>Sign In to Your </h1>
        <div className='text-gray-400 fw-bold fs-4'>
          Need Access?
          <Link to='/auth/request' className='link-primary fw-bolder ms-3'>
            Request an invite
          </Link>
        </div>
      </div>

      {formik.status && (
        <div className='mb-lg-8 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-white'>Email</label>
        <input
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            { 'is-invalid': formik.touched.email && formik.errors.email },
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
          type='email'
          name='email'
          autoComplete='off'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container mt-3'>
            <span role='alert' className='text-danger'>{formik.errors.email}</span>
          </div>
        )}
      </div>
      
      <div className='fv-row mb-10'>
        <div className='d-flex justify-content-between'>
          <div className='d-flex flex-stack mb-2'>
            <label className='form-label fw-bolder text-white fs-6 mb-0'>Password</label>
            
            <Link
              to='/auth/forgot-password'
              className='link-primary fs-6 fw-bolder ms-3'
            >
              Forgot Password?
            </Link>
          </div>
        </div>
        <input
          type='password'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container mt-3'>
            <div className='fv-help-block'>
              <span role='alert' className='text-danger'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>

      <div className='text-center'>
        <button
          type='submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Continue</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              <span className='spinner-border spinner-border-sm align-middle'></span>
            </span>
          )}
        </button>
      </div>
    </form>
  )
}
